import {
    type MrBillItem,
    type MrBillItemsGroup,
} from '@components/ui/hotelPage&reserve&view/reserve-bill/types';

const useBillEntries = () => {
    const invoiceStore = useInvoiceStore();

    const billEntries = computed((): MrBillItemsGroup[] =>
        invoiceStore.entries
            .filter(e => e.prices.length)
            .map(entry => ({
                title: entry.itineraryPackage?.invoiceTitle ?? '',
                items: entry.prices.map(price => ({
                    count: price.count,
                    title: price.title || '',
                    unitPrice: price.price,
                })),
            }))
    );
    const billDiscounts = computed((): MrBillItem[] =>
        invoiceStore.titledDiscounts.map(discount => ({
            unitPrice: discount.price,
            title: discount.title,
            count: 1,
        }))
    );
    const billLoading = computed((): boolean => invoiceStore.isLoadingEntries);

    const preBillEntries = computed((): MrBillItemsGroup[] =>
        invoiceStore.preInvoiceEntries
            .filter(e => e.prices.length)
            .map(entry => ({
                title: entry.itineraryPackage?.invoiceTitle ?? '',
                items: entry.prices.map(price => ({
                    count: price.count,
                    title: price.title || '',
                    unitPrice: price.price,
                    unknownPrice: price.showAsUnknown,
                })),
            }))
    );
    const preBillDiscounts = computed((): MrBillItem[] =>
        invoiceStore.preInvoiceDiscounts.map(discount => ({
            unitPrice: discount.price,
            title: discount.title,
            count: 1,
        }))
    );
    const preBillLoading = computed(
        (): boolean => invoiceStore.isLoadingPreEntries
    );

    return {
        billEntries,
        billDiscounts,
        billLoading,
        preBillEntries,
        preBillDiscounts,
        preBillLoading,
    };
};

export default useBillEntries;
